import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
	client: {
		NEXT_PUBLIC_IFRAME_LICENSE: z.string().min(1),
		NEXT_PUBLIC_API_URL: z.string().url(),
		NEXT_PUBLIC_POSTHOG_KEY: z.string().min(1),
		NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: z.string().min(1),
		NEXT_PUBLIC_STRIPE_PRICING_TABLE_ID: z.string().min(1),
		NEXT_PUBLIC_STRIPE_PRICING_TABLE_ID_DARK: z.string().min(1),
		NEXT_PUBLIC_X_PIXEL_ID: z.string().optional(),
		NEXT_PUBLIC_FREE_TRIAL_STARTED_X_EVENT_ID: z.string().optional(),
		NEXT_PUBLIC_GLEAP_API_KEY: z.string().optional(),
	},
	runtimeEnv: {
		NEXT_PUBLIC_IFRAME_LICENSE: process.env.NEXT_PUBLIC_IFRAME_LICENSE,
		NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
		NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
		NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY:
			process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
		NEXT_PUBLIC_STRIPE_PRICING_TABLE_ID:
			process.env.NEXT_PUBLIC_STRIPE_PRICING_TABLE_ID,
		NEXT_PUBLIC_STRIPE_PRICING_TABLE_ID_DARK:
			process.env.NEXT_PUBLIC_STRIPE_PRICING_TABLE_ID_DARK,
		NEXT_PUBLIC_X_PIXEL_ID: process.env.NEXT_PUBLIC_X_PIXEL_ID,
		NEXT_PUBLIC_FREE_TRIAL_STARTED_X_EVENT_ID:
			process.env.NEXT_PUBLIC_FREE_TRIAL_STARTED_X_EVENT_ID,
		NEXT_PUBLIC_GLEAP_API_KEY: process.env.NEXT_PUBLIC_GLEAP_API_KEY,
	},
});
